import './Block.css';
import { useRef, useState } from 'react';
import useBlockSelection from '/src/features/editor/hook/block/useBlockSelection';
import { useTreeStateContext } from '../../contexts/TreeContext'; 
import useBlockMagnetPosition from '/src/features/editor/hook/block/useBlockMagnetPosition';
import usePath from '/src/features/editor/hook/path/usePath';
import NiceModal from '@ebay/nice-modal-react'
import FormList from '../Form/FormList';
import { useBotStateContext } from '../../contexts/BotContext';
import useCategories from '../../hook/category/useCategories';
import binarySearchString from '../../utils/binarySearchString';
function Block({children, x, y, className, id, imageLow, lowVersion, type, data, childrenBlocks, name}) {

    const { selectBlock, dropBlock, shiftKey } = useBlockSelection();

    const { blocks } = useTreeStateContext();

    const { getCategoryById } = useCategories();
    const { setMagnetPosition, resetMagnetPosition } = useBlockMagnetPosition();

    const { createPath } = usePath();
    
    const [isDraggingBlock, setIsDraggingBlock] = useState(false);
    const { errors } = useBotStateContext();
    
    const refBlock = useRef(null);

    const magnetBlock = className != 'scenario' && className != 'template';

    const componentProps = { data, childrenBlocks, name, id };

    var Component = FormList[type.name];

    const block_error = errors[id];
    let error = false;
    if(type.name == 'magic' && block_error) {
        const indexBlock = binarySearchString(blocks, id, 'object_id');
        let block = blocks[indexBlock];
        error = block_error.errors.filter(child => child.type == 'Block Error').length && (block.data.is_constant == 1)? true : false;
    }

    className = shiftKey ? `${className} shiftKey` : `${className}`; 
    // When click on the block, we open the right-editor to edit form
    const onClick = (e) => {
        const indexBlock = binarySearchString(blocks, id, 'object_id');
        let block = blocks[indexBlock];
        let infoCategory = getCategoryById(block.bot_category_id);
        if (infoCategory?.category.locked){ // if block has category and if this one is locked then we don't open the modal
            return;
        }
        // List of condition to not enter in the right-editor windows && cannot enter in the windows if click on menu button
        if(className == 'template ' || e.target.classList.contains("context_element") || e.target.classList.contains("context_element_lockable") ) return
   
        if(createPath(id)) return;
        var classList = ["sub_out_block", "sub_out_block_zero" ,"in_block", 'delete', 'export', 'duplicate', 'block_action_stat', 'block_magic_jump_btn'];
        if(classList.some(className => e.target.classList.contains(className))) return;
        
        const element = document.getElementById(id);
        if(!element || [...element.classList].some(className => className == 'shiftKey')) return

        const oldElement = document.querySelector('.block.selected');
        if(oldElement) {
            oldElement.classList.remove('selected');
        }
        if (isDraggingBlock == true){
            setIsDraggingBlock(false);
        }
        else{ // permet de ne plus ouvrir la modal apres avoir bouge un block, car tres penible
            NiceModal.show('editor-window', { Component,  componentProps }); 
        }
        //NiceModal.show('editor-window', { Component,  componentProps }); 

        element.classList.add('selected')
    }

    return (
        <div ref={refBlock} 
            className={"block " + className} 
            id={id}
            onMouseUp={(e) => dropBlock(e, id)} 
            onMouseMove={(e) => setIsDraggingBlock(document.getElementById(id).classList.contains("grabbed") )}
            onMouseDown={(e) => selectBlock(e, id)}
            onMouseEnter={() => magnetBlock && setMagnetPosition(id)}
            onMouseLeave={() => magnetBlock && resetMagnetPosition()}
            onClick={onClick}
            style={{transform : "translate3d(" + x + "px, " + y + "px, 0)", backgroundImage : lowVersion ? `url(${imageLow})` : '', ...(error ? {border : "2px solid var(--pink)"} : {}) }}>
            {children}
        </div>
    )
}

export default Block;